import { useEffect, useContext, useState } from 'react';

import Card from './layout/Card';
import SetBookmark from './SetBookmark';
import AuthContext from '../store/AuthProvider';
import ArticlesContext from '../store/ArticlesProvider';
import UserInfoContext from '../store/UserInfoProvider';
import classes from './LoadFavorite.module.css';

const LoadFavorite = () => {
  const [error, setError] = useState('');
  const [loadedArticles, setLoadedArticles] = useState([]);
  const [loadData, setLoadData] = useState(false);

  const authCtx = useContext(AuthContext);
  const localId = authCtx.localId;
  const articlesCtx = useContext(ArticlesContext);
  const { articles } = articlesCtx;
  const userInfoCtx = useContext(UserInfoContext);
  const { userInfo, userArticles } = userInfoCtx;

  useEffect(() => {
    setLoadedArticles(articles);
  }, [articles]);

  // initで登録データcheck & set
  useEffect(() => {
    if (userInfo === '') {
      fetch(`https://news-tag-node.vercel.app/api/users?usr=${localId}`)
        .then((res) => {
          if (!res.ok) {
            return res.json().then((data) => {
              throw new Error(data.message || 'Unknown error');
            });
          }
          return res.json();
        })
        .then((data) => {
          if (data && Object.keys(data).length !== 0) {
            // ユーザーデータが存在する場合
            // const articles = data[Object.keys(data)[0]].articles;
            // const userId = Object.keys(data)[0];

            // 必要に応じてコメントアウトを復活させて使用できます：
            // if (articles !== undefined) {
            //   for (let i = 0; i < articles.length; i++) {
            //     articlesCtx.addArticles(articles[i]);
            //   }
            //   userInfoCtx.setUserArticles(articles);
            //   setLoadedArticles(articles);
            // }
            // userInfoCtx.setUserInfo(userId);

          } else if (!loadData) {
            // ユーザー登録（POST）
            fetch(`https://news-tag-node.vercel.app/api/users?usr=${localId}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                data: localId,
                articles: [],
              }),
            })
              .then((res) => {
                if (!res.ok) {
                  return res.json().then((data) => {
                    throw new Error(data.message || 'Unknown error');
                  });
                }
              })
              .catch((error) => setError('Database Error: ' + error.message));

            setTimeout(() => {
              setLoadData(true);
            }, 1000);
          }
        })
        .catch((error) => setError('DB Error: ' + error.message));
    } else {
      setLoadedArticles(userArticles);
    }
  }, [loadData, userInfo]);

  return (
    <section>
      {error === '' && loadedArticles.length !== 0 && (
        <>
          <Card articles={loadedArticles} source='mypage' />
          <SetBookmark />
        </>
      )}
      {error === '' && loadedArticles.length === 0 && (
        <>
          <p className={classes.mypage}>
            Bookmark does not seem to have been done yet.
          </p>
          <p className={classes.mypage}>Please bookmark some pages you like.</p>
          <SetBookmark />
        </>
      )}
      {error !== '' && (
        <p className={classes.mypage}>
          Communication with Server failed. Please wait and try again.
        </p>
      )}
    </section>
  );
};

export default LoadFavorite;
